import {
  Component,
  AfterViewInit,
  Renderer2,
  Inject,
  LOCALE_ID,
  PLATFORM_ID,
  ElementRef,
  HostListener,
  DOCUMENT,
  ChangeDetectionStrategy
} from '@angular/core';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import {FontCommonModule} from '../app-common/modules/font-common.module';

interface Language {
    code: string;
    label: string;
    prefix: string;
}

@Component({
    selector: 'app-navigation',
    imports: [RouterLink, RouterLinkActive, FontCommonModule],
    templateUrl: './navigation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './navigation.component.scss'
})
export class NavigationComponent implements AfterViewInit {
    languages: Language[] = [
        {code: 'en-US', label: 'English', prefix: 'en'},
        {code: 'fr-FR', label: 'Français', prefix: 'fr'},
        {code: 'de-DE', label: 'Deutsch', prefix: 'de'},
        {code: 'es-ES', label: 'Español', prefix: 'es'},
        {code: 'it-IT', label: 'Italiano', prefix: 'it'},
        {code: 'pt-PT', label: 'Português', prefix: 'pt'},
        {code: 'tr-TR', label: 'Türkçe', prefix: 'tr'},
    ];

    currentLanguage: Language;
    isLanguageDropdownOpen = false;

    constructor(
        private renderer: Renderer2,
        private router: Router,
        private elementRef: ElementRef,
        @Inject(DOCUMENT) private document: Document,
        @Inject(LOCALE_ID) private localeId: string,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.currentLanguage = this.languages.find(l => l.code === this.localeId) || this.languages[0];
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        const languageSelector = this.elementRef.nativeElement.querySelector('.language-selector');
        if (languageSelector && !languageSelector.contains(event.target)) {
            this.closeLanguageDropdown();
        }
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    toggleLanguageDropdown() {
        this.isLanguageDropdownOpen = !this.isLanguageDropdownOpen;
    }

    closeLanguageDropdown() {
        this.isLanguageDropdownOpen = false;
    }

    switchLanguage(lang: Language): void {
        if (lang.code === this.currentLanguage.code) return;
        const currentPath = this.router.url;
        this.document.location.href = `/${lang.prefix}${currentPath}`;
    }

    private hoverTimeout: any;
    private hideTimeout: any;

    ngAfterViewInit(): void {
        if (typeof document !== 'undefined') {
            // Sélectionner tous les dropdowns
            const dropdowns = document.querySelectorAll('.dropdown');

            dropdowns.forEach(dropdown => {
                // Ajouter des écouteurs d'événements pour mouseover
                this.renderer.listen(dropdown, 'mouseover', () => {
                    clearTimeout(this.hideTimeout); // Annuler le délai de disparition s'il est actif
                    this.hoverTimeout = setTimeout(() => {
                        const dropdownMenu = dropdown.querySelector('.dropdown-menu');
                        if (dropdownMenu) {
                            this.renderer.addClass(dropdownMenu, 'show');
                            this.renderer.setAttribute(dropdownMenu, 'data-bs-popper', 'static'); // Fixer la position
                        }
                    }, 300); // Délai de 300ms avant d'afficher le menu
                });

                // Ajouter des écouteurs d'événements pour mouseout
                this.renderer.listen(dropdown, 'mouseout', () => {
                    clearTimeout(this.hoverTimeout); // Annuler le délai d'apparition s'il est actif
                    this.hideTimeout = setTimeout(() => {
                        const dropdownMenu = dropdown.querySelector('.dropdown-menu');
                        if (dropdownMenu) {
                            this.renderer.removeClass(dropdownMenu, 'show');
                            this.renderer.removeAttribute(dropdownMenu, 'data-bs-popper');
                        }
                    }, 300); // Délai de 300ms avant de masquer le menu
                });
            });
        }
    }
}
